<template>
    <div>
        <van-search placeholder="请输入搜索关键词" v-model="value" @search="selectValue()"/>
        <div>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div style="border-top: 0.5px solid #333333;">
                    <div class="each" v-for="(i,item) in list" :key="item">
                        <div class="each-id">{{item+1}}</div>
                        <div class="each-number" @click="go_FGurl(i.id,i.packing_num,'false')">{{i.packing_num}}</div>
                        <div class="each-jms">{{i.kh_name}}</div>
                        <div class="each-cz">
                            <div class="cz-size" @click="deleteFG(i.id,item)" style="color: white;background-color: red">
                                <van-icon name="close" size="0.5rem" style="color: white"/>
                            </div>
                            <div class="cz-size" @click="goFGInfo(i.id)" style="color: white;background-color: red">
                                <van-icon name="add-o" size="0.5rem" style="color: white"/>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
  import { Dialog } from "vant";
  import { Toast } from 'vant';
  export default {
    name: "FGlist",
    data(){
      return{
        value:'',
        list: [],
        loading: false,
        finished: false,
        page:1
      }
    },
    mounted(){
    },
    methods: {
      async getdata(){
        let data={
          page:this.page,
          packing_num:this.value
        }
        let packing = await this.get(this.APIOBJ.packingList,data)
        packing.data.data.data.map((i)=>{
          this.list.push(i)
        })
        if(packing.data.data.data.length === 0){
          this.finished = true;
        }
      },
      onLoad() {
        // 异步更新数据
        setTimeout(() => {
          this.getdata()
          // 加载状态结束
          this.page ++
          this.loading = false;
        }, 500);
      },
      selectValue(){
        this.list=[]
        this.page=1
        this.onLoad()
      },
      deleteFG(id,item){
        Dialog.confirm({
          message: "确定删除吗？"
        }).then( async () => {
          let packing = await this.get(this.APIOBJ.packingDel,{id})
          if(packing.data.status === 1){
            this.list.splice(item,1)
          }
          Toast(packing.data.msg)
        });
      },
      goFGInfo(id){
        this.$router.push({path:'/FGlistInfo',query:{FGinfoID:id}});
      },
      go_FGurl(FGid,number,type){
        this.$router.push({path:'/fillingGoods',query:{FGid,number,type}});
      }
    }
  }
</script>

<style lang="less">
.each{
    display: flex;
    margin: 5px 0;
    padding: 5px 0;
    border-bottom: 0.5px solid #333333;
}
    .each-id{
        width: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .each-number{
        width: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: underline;
    }
    .each-jms{
        width: 4.1rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .each-cz{
        display: flex;
        justify-content: space-between;
        width: 1.5rem;
    }
    .cz-size{
        width: 0.7rem;
        height: 0.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>